import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type {
  ContentBoardAvailablePanelTool,
  ContentBoardColor,
  ContentBoardFill,
} from 'features/content-whiteboard/types';
import type { RootState } from 'store/store';

export const CONTENT_WHITEBOARD_DEFAULT_OPACITY = 1;
export const CONTENT_WHITEBOARD_DEFAULT_COLOR: ContentBoardColor = 'black';
export const CONTENT_WHITEBOARD_DEFAULT_TOOL: ContentBoardAvailablePanelTool = 'laser';
export const CONTENT_WHITEBOARD_DEFAULT_FILL: ContentBoardFill = 'none';

interface ContentWhiteboardState {
  panelTool: ContentBoardAvailablePanelTool;
  panelColor: ContentBoardColor;
  panelOpacity: number;
  panelFill: ContentBoardFill;
}

export const initialState: ContentWhiteboardState = {
  panelTool: CONTENT_WHITEBOARD_DEFAULT_TOOL,
  panelColor: CONTENT_WHITEBOARD_DEFAULT_COLOR,
  panelOpacity: CONTENT_WHITEBOARD_DEFAULT_OPACITY,
  panelFill: CONTENT_WHITEBOARD_DEFAULT_FILL,
};

export const contentWhiteboardSlice = createSlice({
  name: 'contentWhiteboard',
  initialState,
  reducers: {
    panelToolChanged(state, action: PayloadAction<ContentBoardAvailablePanelTool>) {
      state.panelTool = action.payload;
    },
    panelColorChanged(state, action: PayloadAction<ContentBoardColor>) {
      state.panelColor = action.payload;
    },
    panelOpacityChanged(state, action: PayloadAction<number>) {
      state.panelOpacity = action.payload;
    },
    panelFillChanged(state, action: PayloadAction<ContentBoardFill>) {
      state.panelFill = action.payload;
    },
  },
});

export const { panelToolChanged, panelColorChanged, panelOpacityChanged, panelFillChanged } =
  contentWhiteboardSlice.actions;

export const selectContentWhiteboardPanelTool = (state: RootState) =>
  state.contentWhiteboard.panelTool;

export const selectContentWhiteboardPanelColor = (state: RootState) =>
  state.contentWhiteboard.panelColor;

export const selectContentWhiteboardPanelOpacity = (state: RootState) =>
  state.contentWhiteboard.panelOpacity;

export const selectContentWhiteboardPanelFill = (state: RootState) =>
  state.contentWhiteboard.panelFill;

export default contentWhiteboardSlice.reducer;
